import {domain} from './../config';

export const getUi = state => state[domain].ui;